import { format } from 'date-fns'

interface RelativeDateParams {
  dateTime?: Date | string | null | undefined
  type?: string
}

const changeDateOnly = (isoString: string, newDate: string): string => {
  if (!isoString) return ''
  return isoString.replace(/^\d{4}-\d{2}-\d{2}/, newDate)
}

const getRelativeDate = ({ dateTime, type }: RelativeDateParams) => {
  
  if (!dateTime) return null;
  
  const inputDateTime = new Date(dateTime)
  switch (type) {
    case 'date':
      return format(inputDateTime, 'E d MMM yyyy')
    case 'time24':
      return format(inputDateTime, 'HH:mm')
    case 'time':
      return format(inputDateTime, 'h:mm a')
    case 'ecTime24':
      return format(changeDateOnly(inputDateTime.toISOString(), "2000-01-01"), 'HH:mm')
    default:
      return format(inputDateTime, "E d MMM yyyy 'at' HH:mm")
  }
}

export default getRelativeDate
